var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-dialog",
    {
      attrs: { persistent: "", "max-width": "600px" },
      model: {
        value: _vm.dialogchangepassword,
        callback: function ($$v) {
          _vm.dialogchangepassword = $$v
        },
        expression: "dialogchangepassword",
      },
    },
    [
      _c(
        "v-overlay",
        { attrs: { value: _vm.loaderOverlay, absolute: true } },
        [
          _c(
            "v-row",
            { attrs: { justify: "center" } },
            [
              _c("v-progress-circular", {
                attrs: { indeterminate: "", size: "64" },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-card",
        [
          _c("v-card-title", [
            _c("h2", { staticClass: "primary--text mb-4" }, [
              _vm._v(_vm._s(_vm.$t("changePasswordQuestion")) + "?"),
            ]),
          ]),
          _c(
            "v-card-text",
            { staticClass: "pb-0 mb-0" },
            [
              _c(
                "v-form",
                [
                  _c(
                    "v-row",
                    [
                      _c("v-text-field", {
                        ref: "firstPassField",
                        attrs: {
                          label: _vm.$t("insertPassword"),
                          autocomplete: "off",
                          rules: [
                            _vm.newPassword1 != _vm.newPassword2
                              ? _vm.$t("passwordNoMatch") + "!"
                              : true,
                            _vm.newPassword1.length < 5
                              ? _vm.$t("passwordTooShort") + "!"
                              : true,
                          ],
                          type: "password",
                          required: "",
                        },
                        on: {
                          keydown: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            )
                              return null
                            return _vm.checkNewPassword.apply(null, arguments)
                          },
                        },
                        model: {
                          value: _vm.newPassword1,
                          callback: function ($$v) {
                            _vm.newPassword1 = $$v
                          },
                          expression: "newPassword1",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    [
                      _c("v-text-field", {
                        attrs: {
                          label: _vm.$t("confirmPassword"),
                          autocomplete: "off",
                          type: "password",
                          rules: [
                            _vm.newPassword1 != _vm.newPassword2
                              ? _vm.$t("passwordNoMatch") + "!"
                              : true,
                          ],
                          required: "",
                        },
                        on: {
                          keydown: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            )
                              return null
                            return _vm.checkNewPassword.apply(null, arguments)
                          },
                        },
                        model: {
                          value: _vm.newPassword2,
                          callback: function ($$v) {
                            _vm.newPassword2 = $$v
                          },
                          expression: "newPassword2",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-layout",
                { staticClass: "mb-0", attrs: { "justify-end": "", row: "" } },
                [
                  _vm.newpasswordonlogin
                    ? _c(
                        "v-flex",
                        { staticClass: "pa-0 ma-0", attrs: { xs6: "" } },
                        [
                          _c("v-checkbox", {
                            staticClass: "pa-0 ma-0",
                            attrs: { label: _vm.$t("resetPassOnLogin") },
                            model: {
                              value: _vm.changePassOnLogin,
                              callback: function ($$v) {
                                _vm.changePassOnLogin = $$v
                              },
                              expression: "changePassOnLogin",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: { color: "primary darken-1" },
                  on: { click: _vm.clearFields },
                },
                [_vm._v(" " + _vm._s(_vm.$t("cancel")) + " ")]
              ),
              _c(
                "v-btn",
                {
                  attrs: {
                    color: "green white--text darken-1",
                    disabled:
                      _vm.newPassword1 != _vm.newPassword2 ||
                      _vm.newPassword1 == "" ||
                      _vm.newPassword1.length < 5,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.checkNewPassword()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("save")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }